import { Clapperboard, MonitorX } from 'lucide-react';

/** Shown when the browser lacks the storage capabilities the editor relies on. */
export function UnsupportedBrowser({ reason }: { reason?: string }) {
  return (
    <div className="picker unsupported">
      <div className="picker-brand">
        <Clapperboard size={28} />
        <h1>Cutroom</h1>
      </div>
      <section className="panel unsupported-panel">
        <div className="dialog-body">
          <MonitorX size={32} />
          <h2>This browser isn’t supported yet</h2>
          <p>
            Cutroom edits video straight from a folder on your computer. That needs the File System Access
            API, which is currently available in desktop <strong>Chrome</strong>, <strong>Edge</strong>,{' '}
            <strong>Opera</strong> and <strong>Arc</strong>.
          </p>
          {reason && <p className="muted">{reason}</p>}
        </div>
      </section>
    </div>
  );
}
